import { Button } from '@e2n/ui';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useTranslation } from 'react-i18next';
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function DesktopFooter() {
  const { t } = useTranslation();
  const { ctx } = useAnlageassistentContext();
  const form = useAnlageassistentFormContext();

  const handleCreate = () => {
    form.handleSubmit();
  };

  return (
    <div className="px-8 py-4 bg-neutrals-100 border-t border-neutrals-300 flex sticky bottom-0">
      {ctx.hasPrevious() && (
        <Button
          variant="outline"
          onClick={() => {
            ctx.previous();
          }}>
          {t('domain.mitarbeiter.create.navigationZurueck')}
        </Button>
      )}
      {ctx.hasNext() && (
        <Button
          className="ml-auto"
          onClick={() => {
            ctx.next();
          }}>
          {t('domain.mitarbeiter.create.navigationWeiter')}
        </Button>
      )}
      {ctx.state.steps[ctx.state.currentStepIndex].type === 'summary' && (
        <form.Subscribe selector={(state) => [state.isSubmitting]}>
          {([isSubmitting]) => (
            <Button
              className="ml-auto"
              onClick={handleCreate}
              disabled={isSubmitting}>
              {isSubmitting ? (
                <FontAwesomeIcon icon={faSpinnerThird} spin className="mr-2" />
              ) : null}
              {t('domain.mitarbeiter.create.submitButton')}
            </Button>
          )}
        </form.Subscribe>
      )}
    </div>
  );
}

export function MobileFooter() {
  const { t } = useTranslation();
  const { ctx } = useAnlageassistentContext();
  const form = useAnlageassistentFormContext();

  const handleCreate = () => {
    form.handleSubmit();
  };
  return (
    <div className="sticky bottom-0 p-4 border-t border-neutrals-300 bg-neutrals-100 mt-auto">
      {ctx.hasNext() ? (
        <Button className="w-full" onClick={() => ctx.next()}>
          {t('domain.mitarbeiter.create.navigationWeiter')}
        </Button>
      ) : (
        <form.Subscribe selector={(state) => [state.isSubmitting]}>
          {([isSubmitting]) => (
            <Button
              className="w-full"
              onClick={handleCreate}
              disabled={isSubmitting}>
              {isSubmitting ? (
                <FontAwesomeIcon icon={faSpinnerThird} spin className="mr-2" />
              ) : null}
              {t('domain.mitarbeiter.create.submitButton')}
            </Button>
          )}
        </form.Subscribe>
      )}
    </div>
  );
}
